<template>
  <div class="guestList">
    <h1>{{ $t("events.title") }}</h1>

    <SwitchButtons name="lostItems" :values="types" @tipo="getAllTheEvents" />
    <div class="cards-row">
      <router-link class="newEvent" :to="{
                name: 'New Event'
              }">
        <div class="text-center">
          <img src="../../assets/img/icon/add.png" alt />
        </div>
      </router-link>
      <div class="eventCard" v-for="(event, index) in events" :key="index">
        <div class="alert" v-if="event.isHappening">
          <span>{{ $t("events.happeningNowAlert") }}</span>
        </div>
        <div class="card-body-event" :class="event.isHappening ? '' : 'withOutAlert'">
          <h4 class="bolded">{{ event.name }}</h4>
          <p>{{ event.formatEventDateFrom }} a {{ event.formatEventDateTo }}</p>
          <div class="description">
            <p>{{ event.description }}</p>
          </div>
          <div class="validity">
            <div class="survey">
              <p v-if="!event.sendSurvey">
                <img
                  class="alert-img"
                  v-if="event.surveyId === null"
                  src="../../assets/img/icon/alert.png"
                />
                <span
                  v-if="event.surveyId === null"
                  class="red-text"
                >{{ $t("events.withOutSurvey") }}</span>
              </p>
              <span class="bolded" v-if="event.surveyId !==null">{{ $t("events.withSurvey") }}</span>
            </div>
            <div class="validity-dates">
              <span>{{ $t("events.validity") }}:</span>
              <small v-if="!isHistory">
                {{ event.formatAppDateFrom }} {{ event.a }}
                {{ event.formatAppDateTo }}
              </small>
              <small v-if="isHistory">{{ $t("events.expired") }}</small>
            </div>
          </div>
          <div class="actions" :class="event.isHappening ? 'mb-2' : 'withOutAlertActions'">
            <div class="icons">
              <i
                v-if="!event.isHappening"
                @click="openModal(event)"
                class="far fa-trash-alt pointer"
              ></i>
            </div>
            <div class="content">
              <router-link
                v-if="!isHistory"
                :to="{
                name: 'Details Event',
                params: {
                  id: event.id,
                  details: true,
                  isHappeningEvent: event.isHappening
                }
              }"
              >{{ $t("events.seeEdit") }}</router-link>
              <!-- Ver solo en historial -->
              <router-link
                v-if="isHistory"
                :to="{
                name: 'Details Event',
                params: {
                  id: event.id,
                  details: true,
                  isHistory: true
                }
              }"
              >{{ $t("events.onlySee") }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title bolded">{{ $t("events.guest.modal.atention") }}</h6>
      </template>
      <template>
        <p>{{ $t("events.guest.deleteAlert") }} {{singleEvent.name}} ?</p>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn mr-4" @click="closeModal">
            {{
            $t("map.benefits.list.modal.cancel")
            }}
          </span>
          <span
            type="control button"
            class="control entered-btn"
            @click="deleteEvent"
          >{{ $t("events.guest.delete") }}</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Events.js";
const api = new API_SERVICE();
const SwitchButtons = () => import("@/components/Switch");
import moment from "moment";
const Modal = () => import("@/components/Modal");

export default {
  components: {
    SwitchButtons,
    Modal,
  },
  data() {
    return {
      isHappening: false,
      events: [],
      isHistory: false,
      modalActive: false,
      singleEvent: null,
    };
  },
  async beforeMount() {
    await this.getAllTheEvents();
  },
  methods: {
    openModal: function (event) {
      this.modalActive = true;
      this.singleEvent = event;
    },
    closeModal: function () {
      this.modalActive = false;
    },
    async getAllTheEvents(type) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let flag = false;
        if (type === "history") {
          flag = true;
          this.isHistory = true;
        } else {
          flag = false;
          this.isHistory = false;
        }

        const resp = await api.getAllEvents(flag);
        this.events = resp.events;
        let today = new Date();
        for (let index = 0; index < this.events.length; index++) {
          //Parseo de las fechas para mostrarlas en las cards
          moment.locale("es");
          let parseEventDateFrom = moment(
            this.events[index].validFromEvent
          ).format("DD MMMM YYYY HH:mm");
          let parseEventDateTo = moment(this.events[index].validToEvent).format(
            "DD MMMM YYYY HH:mm"
          );
          let parseAppDateFrom = moment(this.events[index].validFromApp).format(
            "DD MMMM YYYY HH:mm"
          );
          let parseAppDateTo = moment(this.events[index].validToApp).format(
            "DD MMMM YYYY HH:mm"
          );

          if (
            today >= new Date(this.events[index].validFromEvent) &&
            today <= new Date(this.events[index].validToEvent)
          ) {
            this.events[index].isHappening = true;
          } else {
            this.events[index].isHappening = false;
          }
          this.events[index].formatEventDateFrom = parseEventDateFrom;
          this.events[index].formatEventDateTo = parseEventDateTo;
          this.events[index].formatAppDateFrom = parseAppDateFrom;
          this.events[index].formatAppDateTo = parseAppDateTo;
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    async deleteEvent() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.editEvent(
          { published: false },
          this.singleEvent.id
        );
        await this.getAllTheEvents();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    },
  },
  computed: {
    types: function () {
      return [
        {
          label: this.$t("events.tabs.actives"),
          value: "actives",
        },
        {
          label: this.$t("events.tabs.history"),
          value: "history",
        },
      ];
    },
  },
};
</script>
<style>
.cards-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 1rem;
}
.cards-row .newEvent {
  width: 15%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  height: 255px;
  cursor: pointer;
  margin-right: 1.5rem;
}
.cards-row .newEvent img {
  width: 60%;
}
.cards-row .eventCard {
  width: 30%;
  background: #fff;
  margin-right: 1.5rem;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 2rem;
  position: relative;
}
.cards-row .eventCard .alert {
  background: #bb0a30;
  color: #fff;
  text-align: center;
  border-radius: 0px;
  font-weight: bold;
}
.cards-row .eventCard .card-body-event {
  padding: 0.5rem 1rem;
}

.cards-row .eventCard .card-body-event .validity {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}
.cards-row .eventCard .card-body-event .validity .survey {
  display: flex;
  width: 50%;
}
.cards-row .eventCard .card-body-event .validity .survey span {
  margin-top: 5px;
  font-weight: 500;
}
.red-text {
  color: #bb0a30;
  font-weight: bold !important;
}
.cards-row .eventCard .card-body-event .validity .validity-dates {
  display: flex;
  width: 50%;
  margin-left: auto;
  color: #b3b3b3;
  justify-content: end;
}
.cards-row .eventCard .card-body-event .validity .validity-dates small {
  width: 70%;
  padding-top: 3px;
  padding-left: 5px;
}
.cards-row .eventCard .card-body-event .actions {
  display: flex;
  width: 100%;
  margin-bottom: 2rem;
}
.cards-row .eventCard .card-body-event .actions .icons {
  display: flex;
  align-items: center;
  width: 40%;
  margin-right: auto;
}
.cards-row .eventCard .card-body-event .actions .icons i {
  margin-right: 1rem;
  font-size: 1.3rem;
}
.cards-row .eventCard .card-body-event .actions .content a {
  color: black;
  font-size: 1.1rem;
}
.bolded {
  font-weight: bold;
}
.withOutAlert {
  padding: 1.5rem !important;
}
.withOutAlertActions {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}
.description {
  overflow-y: scroll;
  height: 80px;
  overflow-x: hidden;
  overflow-wrap: break-word;
}
.description ::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.description ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.description ::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.description ::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.pointer {
  cursor: pointer;
}
.guestList .controls {
  display: flex;
  justify-content: end;
  align-items: flex-end;
}
.guestList .controls .cancel-btn,
.guestList .controls .entered-btn {
  cursor: pointer;
}
.guestList .controls .entered-btn {
  background: #000 !important;
  color: #fff !important;
  padding: 0.5rem;
}
.guestList .controls .cancel-btn {
  padding: 0.5rem;
}
.edit-icon {
  cursor: pointer;
}
.bolded {
  font-weight: bold !important;
  color: #000;
}
.alert-img {
  margin-top: -4px !important;
}
</style>
<style>
@media (min-width: 768px) and (max-width: 1440px) {
  .cards-row .eventCard {
    width: 37% !important;
  }
  .cards-row .newEvent {
    width: 18%;
  }
}
</style>